// Utility function to calculate distance between two points
const calculateDistance = (lat1, lon1, lat2, lon2) => {
  if (!lat1 || !lon1 || !lat2 || !lon2) return 0;
  const R = 3959; // Radius of Earth in miles
  const deg2rad = (deg) => deg * (Math.PI/180);
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);
  const a = 
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * 
    Math.sin(dLon/2) * Math.sin(dLon/2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  return R * c;
};

// Utility function to convert school comparison data to CSV format
export const convertSchoolComparisonToCSV = (schools, selectedSchool) => {
  if (!schools || schools.length === 0) return '';
  
  // Create header row
  const headerRow = [
    '"School Name"',
    '"NCES ID"',
    '"State School ID"',
    '"Distance (mi)"',
    '"2019 to 2023 Change"',
    '"23-24 Enrollment"'
  ];
  
  // Create data rows
  const dataRows = schools.map(school => {
    // Calculate distance from selected school
    const distance = school.isMainSchool ? 
      'N/A' : 
      calculateDistance(
        selectedSchool?.latitude,
        selectedSchool?.longitude,
        school.latitude,
        school.longitude
      ).toFixed(1);

    // Calculate enrollment change
    const enrollmentChange = school.isMainSchool ? 
      (school.currentEnrollment && school.previousEnrollment ? 
        ((school.currentEnrollment - school.previousEnrollment) / school.previousEnrollment) * 100 : null) :
      (school.currentEnrollment && school.previousEnrollment ?
        ((school.currentEnrollment - school.previousEnrollment) / school.previousEnrollment) * 100 : null);

    const changeValue = typeof enrollmentChange === 'number' ? 
      `${enrollmentChange > 0 ? '+' : ''}${Math.round(enrollmentChange)}%` : 
      'New/Newer School';

    return [
      `"${(school.name || '').replace(/"/g, '""')}"`,
      `"${school.ncessch || ''}"`,
      `"${school.state_school_id || ''}"`,
      `"${distance}"`,
      `"${changeValue}"`,
      `"${school.currentEnrollment?.toLocaleString() || 'N/A'}"`
    ].join(',');
  });
  
  // Combine header and data rows
  return [headerRow.join(','), ...dataRows].join('\n');
};

// Function to trigger school comparison CSV download
export const downloadSchoolComparisonCSV = (schools, selectedSchool, schoolName) => {
  const csvContent = convertSchoolComparisonToCSV(schools, selectedSchool);
  
  // Create filename with school name and date
  const sanitizedSchoolName = schoolName.replace(/[^a-z0-9]/gi, '_').toLowerCase();
  const date = new Date().toISOString().slice(0, 10);
  const filename = `${sanitizedSchoolName}_area_school_comparison_${date}.csv`;
  
  // Create a Blob containing the CSV data
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  
  // Create a download link and trigger the download
  const link = document.createElement('a');
  
  // Create object URL for the Blob
  const url = URL.createObjectURL(blob);
  
  link.href = url;
  link.setAttribute('download', filename);
  link.style.display = 'none';
  
  // Add link to the document, click it, and remove it
  document.body.appendChild(link);
  link.click();
  
  // Clean up
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
